/* bs-main-cart — Página de carrito. Custom element <bs-main-cart>.

   - Cantidades por AJAX (POST /cart/change.js con Section Rendering); re-renderiza esta
     sección Y el drawer (bs-cart-drawer) para mantenerlos en sync. Dispara 'cart:update'.
   - "Guardar": el botón lleva .wishlist-button (bs-wishlist.js lo añade a Favoritos).
     El producto se MANTIENE en el carrito (no se elimina) — solo se marca como favorito.
   - Toggle de código de descuento + aplicar (/discount/CODE). Carrusel de recomendados. */
(function () {
  'use strict';

  class BSMainCart extends HTMLElement {
    connectedCallback() {
      if (this.__bsInit) return;
      this.__bsInit = true;
      this.changeUrl = this.getAttribute('data-change-url') || '/cart/change.js';
      this.sectionId = this.getAttribute('data-section-id');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    onClick(e) {
      var t = e.target;
      var item = t.closest('.bs-main-cart__item');
      if (t.closest('[data-bs-cart-minus]') && item) { e.preventDefault(); this.step(item, -1); return; }
      if (t.closest('[data-bs-cart-plus]') && item) { e.preventDefault(); this.step(item, 1); return; }
      if (t.closest('[data-bs-cart-remove]') && item) { e.preventDefault(); this.setQty(item.getAttribute('data-key'), 0); return; }
      // Guardar = añadir a Favoritos (lo gestiona bs-wishlist.js al pulsar .wishlist-button).
      // NO se quita del carrito: el producto sigue en la compra, solo se marca como favorito.
      if (t.closest('[data-bs-cart-promo-toggle]')) { e.preventDefault(); this.togglePromo(t.closest('[data-bs-cart-promo-toggle]')); return; }
      if (t.closest('[data-bs-cart-promo-apply]')) { e.preventDefault(); this.applyPromo(); return; }
      if (t.closest('[data-bs-cross-prev]')) { e.preventDefault(); this.scrollCross(-1); return; }
      if (t.closest('[data-bs-cross-next]')) { e.preventDefault(); this.scrollCross(1); return; }
    }

    onChange(e) {
      var input = e.target.closest('[data-bs-cart-qty]');
      if (!input) return;
      var item = input.closest('.bs-main-cart__item');
      if (!item) return;
      var min = parseInt(item.getAttribute('data-min'), 10) || 1;
      var stepN = parseInt(item.getAttribute('data-step'), 10) || 1;
      var max = item.getAttribute('data-max') ? parseInt(item.getAttribute('data-max'), 10) : null;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) val = min;
      if (max && val > max) val = max;
      // ajusta al incremento válido
      if (stepN > 1) {
        var over = (val - min) % stepN;
        if (over !== 0) val = val - over;
      }
      this.setQty(item.getAttribute('data-key'), val);
    }

    step(item, dir) {
      var input = item.querySelector('[data-bs-cart-qty]');
      var current = parseInt(input ? input.value : '1', 10) || 1;
      var min = parseInt(item.getAttribute('data-min'), 10) || 1;
      var stepN = parseInt(item.getAttribute('data-step'), 10) || 1;
      var max = item.getAttribute('data-max') ? parseInt(item.getAttribute('data-max'), 10) : null;
      var next = current + dir * stepN;
      if (next < min) next = dir < 0 ? 0 : min;
      if (max && next > max) next = max;
      this.setQty(item.getAttribute('data-key'), next);
    }

    setQty(key, qty) {
      if (!key) return;
      this.mutate({ id: key, quantity: qty });
    }

    togglePromo(btn) {
      var promo = this.querySelector('[data-bs-cart-promo]');
      if (!promo) return;
      var open = promo.hasAttribute('hidden');
      if (open) { promo.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); var inp = promo.querySelector('input'); if (inp) inp.focus(); }
      else { promo.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    }

    applyPromo() {
      var input = this.querySelector('[data-bs-cart-promo-input]');
      var code = input ? input.value.trim() : '';
      if (!code) { if (input) input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    scrollCross(dir) {
      var row = this.querySelector('[data-bs-cross-row]');
      if (!row) return;
      var card = row.querySelector('.bs-main-cart__cross-card');
      var amount = card ? (card.offsetWidth + 16) * 2 : 400;
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    /* ===== AJAX + Section Rendering ===== */
    sectionsToRender() {
      var ids = [];
      if (this.sectionId) ids.push(this.sectionId);
      if (document.querySelector('bs-cart-drawer')) ids.push('bs-cart-drawer');
      return ids;
    }

    mutate(body) {
      var self = this;
      this.classList.add('is-loading');
      var payload = Object.assign({}, body, {
        sections: this.sectionsToRender().join(','),
        sections_url: window.location.pathname
      });
      fetch(this.changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.sections) self.applySections(cart.sections);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { self.classList.remove('is-loading'); });
    }

    applySections(sections) {
      // Esta página
      if (this.sectionId && sections[this.sectionId]) {
        var doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');
        var fresh = doc.querySelector('[data-bs-main-cart]');
        if (fresh) {
          // carrito vacío tras la última eliminación → recargar para el estado vacío completo
          if (!fresh.querySelector('.bs-main-cart__grid') && this.querySelector('.bs-main-cart__grid')) {
            window.location.reload();
            return;
          }
          this.innerHTML = fresh.innerHTML;
        }
      }
      // Drawer (si presente)
      if (sections['bs-cart-drawer']) {
        var ddoc = new DOMParser().parseFromString(sections['bs-cart-drawer'], 'text/html');
        var newPanel = ddoc.querySelector('.bs-cart-drawer__panel');
        var drawer = document.querySelector('bs-cart-drawer');
        var curPanel = drawer && drawer.querySelector('.bs-cart-drawer__panel');
        if (newPanel && curPanel) curPanel.innerHTML = newPanel.innerHTML;
      }
    }
  }

  if (!customElements.get('bs-main-cart')) {
    customElements.define('bs-main-cart', BSMainCart);
  }
})();
